import { gql } from 'apollo-boost';
import { INTERACTIVE_MESSAGE_FIELDS } from '../../fragments/message/interactive-message-fields';

export const DEBUG_REGENERATE_DAILY_REVIEW = gql`
    mutation($reviewId: ID!) {
        debugRegenerateDailyReview(reviewId: $reviewId) {
            id
            localDate
            timezone
            period
            periodKey
            summary
            sections {
                savedCount
                stackBreakdown {
                    stackId
                    title
                    count
                }
                suggestions {
                    messageId
                    suggestedFolderId
                    suggestedFolderTitle
                    title
                    modelConfidence
                }
                folderProposals {
                    title
                    messageIds
                }
                groupingProposals {
                    rootMessageId
                    memberMessageIds
                    reason
                }
                duplicateProposals {
                    canonicalUrl
                    rootMessageId
                    duplicateMessageIds
                    count
                }
                readingPicks {
                    messageId
                    title
                    sourceHost
                    url
                    description
                }
                openTasks {
                    messageId
                    caption
                }
                themes {
                    entityName
                    entityType
                    count
                    messageIds
                    messages {
                        ${INTERACTIVE_MESSAGE_FIELDS}
                    }
                }
            }
            coverage {
                expected
                present
            }
            status
        }
    }
`;
